import { render, staticRenderFns } from "./buyerModel.vue?vue&type=template&id=05e75c02&scoped=true&"
import script from "./buyerModel.vue?vue&type=script&lang=js&"
export * from "./buyerModel.vue?vue&type=script&lang=js&"
import style0 from "./buyerModel.vue?vue&type=style&index=0&id=05e75c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e75c02",
  null
  
)

export default component.exports